var map = {
	"./account/router/index.js": "cbbe",
	"./announcement/router/index.js": "a08a",
	"./config/router/index.js": "2331",
	"./dashboard/fwsed/router/index.js": "e99b",
	"./dashboard/platform/router/index.js": "12e9",
	"./file-manager/router/index.js": "7be4",
	"./firm-audit/router/index.js": "c10e",
	"./firm-policy/router/index.js": "8874",
	"./firm/router/index.js": "7947",
	"./log/router/index.js": "cfab",
	"./mail-log/router/index.js": "07d7",
	"./notification-type/router/index.js": "ec5a",
	"./organization/router/index.js": "ce88",
	"./policy/router/index.js": "3186",
	"./question/router/index.js": "d41b",
	"./report-template/router/index.js": "3aed",
	"./role-access/router/index.js": "9d4e",
	"./role/router/index.js": "154a",
	"./workspace/router/index.js": "3ead"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b575e";